<template>
  <v-app id="NextSysDashboard">
    <v-layout class="fill-height d-flex flex-wrap">
      <v-navigation-drawer
        v-model="mainSidebar"
        :mini-variant.sync="mini"
        mini-variant-width="110"
        permanent
        class="mainsidebar"
        app
        style="height: -webkit-fill-available !important;"
      >
        <v-list-item class="px-2 mt-3">
          <v-btn
            icon
            class="heading-btn"
            @click.stop="mini = !mini"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>

          <!--<v-list-item-title class="logo">PrimeCMS</v-list-item-title>-->
          <v-list-item-title class="logo"><img width="145px" src="https://i.imgur.com/J8CnA93.png" /></v-list-item-title>
          
          <!--<span class="subtitle">Agency</span>-->

        </v-list-item>

        <v-list>
          <v-list-item
            v-for="item in itemsData"
            :key="item.title"
            class="navigation-btn"
            :to="item.path"
            active-class="navigation-active"
            dense
            :ripple=false
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <!--<v-list-item-icon>
              <v-btn @click.stop="drawer = !drawer" elevation="0" small fab></v-btn>
            </v-list-item-icon>-->

            <v-list-item-content class="navigation-content">
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

         

        </v-list>
      </v-navigation-drawer>
      <!--<v-app-bar
        app
        color="indigo"
        dark
      >
        <v-app-bar-nav-icon @click.stop="mini = !mini"></v-app-bar-nav-icon>
        <v-toolbar-title>Application</v-toolbar-title>
      </v-app-bar>-->
      <v-main app>
        <router-view :permissions="permissions"></router-view>
      </v-main>
    </v-layout>
    <!--<v-footer
      color="indigo"
      app
    >
      <span class="white--text">&copy; 2019</span>
    </v-footer>-->
  </v-app>
</template>
<script>
import VueCookies from 'vue-cookies'

export default {
  props: {
    source: String
  },
  data: () => ({
    mainSidebar: true,
    items: [
      { title: 'Tableau de bord', icon: 'mdi-monitor-dashboard', path:{name: 'dashboardHome'}, children:[] },
      { title: 'Clients', icon: 'mdi-account', permission: 'browse_client', path:{name: 'listingCustomer'}, children:[] },
      { title: 'Base de Données', icon: 'mdi-database', permission: 'browse_database', path:{name: 'database'}, children:[] },
      { title: 'Dossiers', icon: 'mdi-folder-multiple-outline', permission: 'browse_dossier',  path:{name: 'listingFolder'} },
      { title: 'Factures', icon: 'mdi-cash-multiple', permission: 'browse_facture', path:{name:'listingFacture'} },
      { title: 'Siteweb', icon: 'mdi-page-layout-header-footer', permission: 'website_edit', path:{name:'websiteSettings'}, children:[] },
      { title: 'Messages', icon: 'mdi-message-text-outline', permission: '', path:{name:'dashboardMessages'}, children:[] },
      { title: 'Statistiques', icon: 'mdi-chart-line', permission: 'statistique', path:{name:'statistics'}, children:[] },
      { title: 'Utilisateurs', icon: 'mdi-account-multiple', permission: 'browse_users', path:{name: 'usersListing'}, children:[] },
      { title: 'Mon Compte', icon: 'mdi-account-tie', path:{name: 'myProfile'}, children:[] },
      { title: 'Logs', icon: 'mdi-note-outline', permission: '', path:{name:'logs'}, children:[] },
      { title: 'Paramètres', icon: 'mdi-cog', path:{name: 'settings'}, children:[] }
    ],
    permissions: [],
    mini: false
  }),
  computed:{

    itemsData : function(){
      let itemsData = []
      this.items.forEach((item, key) => {
        if(item.permission){
          if(this.checkPermission(item.permission)){
            itemsData.push(item)
          }
        }else{
          itemsData.push(item)
        }
      })
      return itemsData
    }
  },
  async mounted(){
    await this.axios
      .get('getPermissionByCredentials/'+this.$store.getters.getUser)
      .then(response => {
          this.$permissions.value = response.data.data
          this.permissions = response.data.data
      })
    this.$cookies.set('lang', 'fr')
    this.checkSession()    
  },
  methods: {
    checkPermission(permission){
      if(this.permissions.indexOf(permission) !== -1){
        return true
      }else{
        return false
      }
    },
    async checkSession(){
      await this.axios
        .get("user/credentials/"+this.$store.getters.getUser+"/check")
        .then(response => {
          if(response.data.token){
            let token = response.data.token
            this.$store.dispatch('login', { token })
            location.reload()
          }
          
        })
    }
  }
}
</script>
<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Montserrat&family=Raleway:wght@400;700&display=swap');
  .mainsidebar {
    box-shadow: 0 0 20px rgba(0,0,0,0.1)
  }
  .mainsidebar >>> .v-navigation-drawer__border {
    display: none;
  }
  #NextSysDashboard {
    $navigation-drawer-border-width : 0;
    background : #f4f8fb;
    font-family: 'Montserrat', sans-serif;
    min-width: fit-content;
  }
  #contentDashboard {
    padding: 0px;
    text-align: left;
    transition: all 2s linear 1s;
  }
  .logo {
    font-family: 'Raleway', sans-serif;
    letter-spacing: -1px;
    font-size: 24px;
    font-weight: 700;
    margin-left: 15px;
    text-align: left;
    background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .v-navigation-drawer__border {
      display: none;
  }
  .navigation-active{
    color: #1976d2 !important;
    font-weight: 700 !important;
    .navigation-content div{
      color: #1976d2 !important;
    }
    .v-icon{
      color: #1976d2 !important;
    }
  }
  .heading-btn {
    margin: 8px auto !important;
    .v-icon{
      color: #9ca6b2;
      font-size:24px;
    }
    .navigation-content {
      text-align:left;
      font-size: 18px;
    }
  }
  .navigation-btn {
    margin: 15px auto !important;
    width: 84%;
    /*.v-list-item__icon{
      //margin-right:18px !important;  
    }*/
    &:before {
      border-radius: 25px;
    }
    .v-icon{
      color: #9ca6b2;
      font-size:24px;
    }
    .navigation-content div{
      text-align: left;
      font-size: 14px;
      font-weight: 700;
      color: #757487;
      letter-spacing:0.3px;
    }
    &.active {
      .v-icon {
        background:#f0f2f8;
        color: #207ddd;
      }
    }
  }
  .spacing-content {
    margin-left: 256px;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/layout.vue